module.exports = __webpack_public_path__ + "img/z_05_bastien-nvs.e172928d.jpg";